var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingProClickShortLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 112,
    viewBox: "0 0 80 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 80,
    height: 106,
    rx: 4,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 59.4443,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8453 71.333H52.2453V57.533C52.2453 54.133 52.2453 46.733 41.9953 46.733C38.1953 46.733 34.4453 47.883 31.7953 50.583L34.9453 53.733C36.5453 52.233 38.8453 51.233 41.3453 51.233C44.5453 51.233 46.8453 52.783 46.8453 55.733V56.383H45.3453C39.3453 56.383 30.2453 56.933 30.2453 64.733C30.2453 69.483 34.5453 71.933 38.9953 71.933C42.1953 71.933 44.9953 70.733 46.6953 68.033H46.8453V71.333ZM46.4953 61.933C46.4953 65.283 44.5453 67.433 40.4453 67.433C38.4953 67.433 36.2453 66.483 36.2453 64.283C36.2453 60.833 41.9453 60.583 45.2453 60.583H46.4953V61.933Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 71 13.999)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 51 13.999)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 31 13.999)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 11 13.999)",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingProClickShortLeft);
export default __webpack_public_path__ + "static/media/jobconfig-binding-proClick-short-left.76f5428b32523b9edbfb934eca4ddd91.svg";
export { ForwardRef as ReactComponent };